import { route as Heat } from '../../../hotel/heat/route.config.ts';
import { route as Help } from '../../../hotel/help/route.config.ts';
import { route as Intro } from '../../../hotel/intro/route.config.ts';
import { route as Volume } from '../../../hotel/volume/route.config.ts';

import component from './page.vue';

const children = [Intro, Heat, Volume, Help];

export default {
  component,
  path: '/(intro|heat|help|volume)',
  children,
  name: 'hotel',
};
